import "./Layout.css";

export const Layout = ({ children }) => (
  <div className="layout">{children}</div>
);
